module.exports = __webpack_public_path__ + "components/advertise-header/static/c__card--4@2-f97eaa190b4a6f06f29c43a3e929043b.jpg";